function fnOpenChat() {
	const eyeCatcherContainer = document.getElementById('eyeCatcherContainer')
	eyeCatcherContainer.click()
}

module.exports = {fnOpenChat}